import { render } from "./Character.vue?vue&type=template&id=3b5855fe&scoped=true"
import script from "./Character.vue?vue&type=script&lang=js"
export * from "./Character.vue?vue&type=script&lang=js"

import "./Character.vue?vue&type=style&index=0&id=3b5855fe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b5855fe"]])

export default __exports__